import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import Contact from "./Contact";
import routes from "./routeNames";
import JoinUs from "./JoinUs";
import Layout from "./components/Layout";
import Who from "./pages/Who";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Community from "./pages/Community";


export default function AppRouter() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={routes.home} element={<App />} />
          <Route path={routes.who} element={<Who />} />
          <Route path={routes.projects} element={<Projects />} />
          <Route path={routes.project()} element={<ProjectDetail />} />
          <Route path={routes.community} element={<Community />} />
          <Route path={routes.contact} element={<Contact />} />
          <Route path={routes.join} element={<JoinUs />} />
        </Routes>
      </Layout>
    </Router>
  );
}